
import axios from "axios";

const service = axios.create({
  baseURL: window._env.BaseUrl || import.meta.env.VITE_APP_API_BASEURL,
  timeout: 0,
});

// axios实例拦截请求
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// axios实例拦截响应
service.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response;
    }
    return response;
  },
  // 请求失败
  (error) => {
    const response = error?.response;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      return Promise.reject(response.data);
    }
  }
);

const request = (config) => {
  const conf = config;
  return new Promise((resolve, reject) => {
    service
      .request(conf)
      .then((res) => {
        const data = res?.data;
        resolve(data);
        // }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export function getEcgIp() {
  return "127.0.0.1";
}

export function get(config){
  return request({ ...config, method: "GET" });
}

export function post(config) {
  return request({ ...config, method: "POST" });
}

export function put(config) {
  return request({ ...config, method: "put" });
}

export function del(config) {
  return request({ ...config, method: "delete" });
}
export default request;
